import { render, staticRenderFns } from "./tourguide.vue?vue&type=template&id=837b0078&scoped=true&"
import script from "./tourguide.vue?vue&type=script&lang=js&"
export * from "./tourguide.vue?vue&type=script&lang=js&"
import style0 from "./tourguide.vue?vue&type=style&index=0&id=837b0078&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837b0078",
  null
  
)

export default component.exports